module.exports = __webpack_public_path__ + "static/img/Cat walk 120 dsk.12ee263.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/Cat walk 120 dsk.jpg
// module id = 78
// module chunks = 1